/* eslint-disable better-mutation/no-mutation */

import * as Validator from 'validator';
import ErrorMessages from '../messages/error-messages';
import Axios from 'axios';

const isPhoneNumber = (str) => {
    return /^(\+?\d{2})?[\d\- ]+$/.test(str);
};

const isAllowedLatinCharacters = (str) => {
    return /^[\u0041-\u024F -:]+$/.test(str);
};

const isAllowedLatinCharactersWithNumbers = (str) => {
    return /^[0-9\u0041-\u024F -:]+$/.test(str);
};

export default function Validate(value, rules, asyncUrl, lang = 'sv') {
    var errors = [],
        copyfor,
        rulesSet,
        currentRule;

    var extractedRules = rules.split(':');

    if (extractedRules.length > 1) {
        copyfor = extractedRules[0].split('=')[1];
        rulesSet = extractedRules[1].split(';');
    } else {
        rulesSet = rules.split(';');
    }

    for (var i = 0; i < rulesSet.length; i++) {
        currentRule = rulesSet[i];
        var code;

        if (currentRule === 'required') {
            if (value === '') {
                if (
                    copyfor &&
                    ErrorMessages[lang]['REQUIRED_' + copyfor.toUpperCase()]
                ) {
                    code = 'REQUIRED_' + copyfor.toUpperCase();
                } else {
                    code = 'REQUIRED_FIELD';
                }
            }
        }

        if (currentRule.indexOf('minlength') > -1) {
            const start = currentRule.indexOf('[') + 1;
            const end = currentRule.indexOf(']');
            const minlength = currentRule.slice(start, end);

            if (value.length < minlength) {
                if (
                    copyfor &&
                    ErrorMessages[lang]['MINLENGTH_' + copyfor.toUpperCase()]
                ) {
                    code = 'MINLENGTH_' + copyfor.toUpperCase();
                } else {
                    code = 'MINLENGTH';
                }
            }
        }

        if (currentRule.indexOf('maxlength') > -1) {
            const start = currentRule.indexOf('[') + 1;
            const end = currentRule.indexOf(']');
            const maxlength = currentRule.slice(start, end);

            if (value.length > maxlength) {
                if (
                    copyfor &&
                    ErrorMessages[lang]['MAXLENGTH_' + copyfor.toUpperCase()]
                ) {
                    code = 'MAXLENGTH_' + copyfor.toUpperCase();
                } else {
                    code = 'MAXLENGTH';
                }
            }
        }

        if (currentRule === 'latinonly') {
            if (!isAllowedLatinCharacters(value)) {
                code = 'INVALID_CHARACTERS';
            }
        }

        if (currentRule === 'latinwithnumbers') {
            if (!isAllowedLatinCharactersWithNumbers(value)) {
                code = 'INVALID_CHARACTERS';
            }
        }

        if (currentRule === 'email') {
            if (!Validator.isEmail(value)) {
                code = copyfor
                    ? 'INVALID_' + copyfor.toUpperCase()
                    : 'INVALID_EMAIL';
            }
        }

        if (currentRule === 'phone') {
            if (!isPhoneNumber(value)) {
                code = copyfor
                    ? 'INVALID_' + copyfor.toUpperCase()
                    : 'INVALID_PHONENUMBER';
            }
        }

        if (currentRule === 'personalid') {
            const rawValue = value.replace('-', '').replace(/ /g, '');
            if (!Validator.isNumeric(rawValue) || rawValue.length !== 10) {
                code = copyfor
                    ? 'INVALID_' + copyfor.toUpperCase()
                    : 'PERSONALID';
            }
        }

        if (currentRule === 'zipcode') {
            const rawValue = value.replace(/[ -]/g, '');
            if (!Validator.isNumeric(rawValue) || rawValue.length !== 5) {
                code = copyfor
                    ? 'INVALID_' + copyfor.toUpperCase()
                    : 'INVALID_ZIPCODE';
            }
        }

        if (code) {
            errors.push({
                code: code,
                description: ErrorMessages[lang][code],
                async: false
            });
        }

        if (errors.length > 0) {
            return new Promise(function (resolve) {
                resolve({
                    isValid: false,
                    errors: errors
                });
            });
        }
    }

    if (asyncUrl) {
        return Axios.post(asyncUrl, {
            value: value.trim()
        })
            .then(() => {
                return {
                    isValid: true,
                    errors: errors
                };
            })
            .catch((err) => {
                if (
                    err.response &&
                    err.response.data &&
                    err.response.status === 400
                ) {
                    errors.push({
                        code: err.response.data.code,
                        description:
                            ErrorMessages[lang][err.response.data.code],
                        async: true
                    });

                    return {
                        isValid: false,
                        errors: errors
                    };
                }
            });
    }

    return new Promise((resolve) => {
        resolve({
            isValid: true,
            errors: errors
        });
    });
}
